import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MongoSettersService} from "../../services/mongo-setters.service";
import {Icomment} from "../../model/Icomment";


@Component({
  selector: 'app-add-comment',
  templateUrl: './add-comment.component.html',
  styleUrls: ['./add-comment.component.scss']
})
export class AddCommentComponent {

  @Input() kgId!: string;
  @Output() commentAdded = new EventEmitter<Icomment>();
  public text:string="";
  public author:string="";
  public submitted = false;
  public sending = false;
  public sendFailed = false;

  constructor(private _mongoSetter: MongoSettersService){

  }

  onClick(): void {
    this.submitted = true;
    if(!this.text.trim() || this.sending){
      return;
    }
    this.sending = true;
    this.sendFailed = false;
    this._mongoSetter.setComment(this.text, this.author, this.kgId!).subscribe({
      next: saved => {
        this.text = "";
        this.author = "";
        this.submitted = false;
        this.sending = false;
        this.commentAdded.emit(saved);
      },
      error: () => {
        this.sending = false;
        this.sendFailed = true;
      }
    });
  }
}
